import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { narrowError } from "@formant/core/common/narrowError";
import { ResponseError } from "@formant/core/common/ResponseError";
import { IRole } from "@formant/core/model/IRole";

import { appStore, roleStore, routerStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { Help } from "../../common/Help";
import {
    IMultiActionButtonAction,
    MultiActionButton,
} from "../../Observe/MultiActionButton";
import * as styles from "./index.scss";

export interface IActionsProps {
    role: IRole;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        const { role } = this.props;
        const { onDelete, onClone } = this;

        const immutableTooltip = role.isImmutable && (
            <div className={styles.help}>
                <Help text="Default roles cannot be altered" size="24" />
            </div>
        );

        const cloneButton: IMultiActionButtonAction = {
            icon: "clone",
            label: "Clone",
            onSelect: onClone,
        };

        const deleteButton: IMultiActionButtonAction = {
            icon: "delete",
            label: "Remove",
            onSelect: onDelete,
        };

        const actions = [
            cloneButton,
            ...(!role.isImmutable ? [deleteButton] : []),
        ];

        return (
            <Buttons>
                {immutableTooltip}
                <MultiActionButton actions={actions} />
            </Buttons>
        );
    }

    private onClone = async () => {
        const { navigate, routeTo } = routerStore;
        await navigate(routeTo.cloneRole({ id: defined(this.props.role.id) }));
    };

    private onDelete = () => {
        const { role } = this.props;

        appStore.setConfirm({
            title: "Delete role",
            message: `Delete role "${role.name}"?`,
            onOk: async () => {
                try {
                    await roleStore.delete(defined(role.id));
                } catch (error) {
                    const responseError = narrowError(error, ResponseError);
                    const { statusCode } = responseError;
                    if (statusCode === 422) {
                        appStore.setSnackbar(
                            "Failed to delete role. Users or teams are currently using this role",
                        );
                    }
                    return;
                }
                appStore.setSnackbar("Role deleted");
            },
        });
    };
}
